export function userLocale(override?: string) {
  function isString(str: string | undefined): str is string {
    return typeof str === "string";
  }

  return (
    [override, navigator.language, navigator.languages[0], "nl-NL"]
      .filter(isString)
      .shift() || "nl-NL"
  );
}
